import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'CollectionSelection',
  props: {
  color: {
    type: String,
    default: undefined
  }
},
  setup(__props) {




const collections = useCollectionsStore()
const { selection } = storeToRefs(collections)
const selectionItems = selection.value.models


return (_ctx: any,_cache: any) => {
  const _component_CollectionListing = _resolveComponent("CollectionListing")!

  return (_openBlock(), _createBlock(_component_CollectionListing, {
    collection: _unref(selectionItems),
    color: __props.color
  }, null, 8, ["collection", "color"]))
}
}

})